<template>
  <div class="step-body step-socials">
    <div class="optional-banner">
      <span class="optional-banner-tag">לא חובה</span>
      <span>הקישורים האלה יופיעו בעמוד האומן הציבורי שלכם · {{ bannerText }}</span>
    </div>

    <div v-for="group in groups" :key="group.id" class="social-group">
      <h4 class="social-group-title">{{ group.label }}</h4>
      <div class="social-grid">
        <div
          v-for="p in platformsInGroup(group.id)"
          :key="p.id"
          class="social-card"
          :class="{ open: isOpen(p.id), filled: hasValue(p.id) }"
        >
          <button type="button" class="social-card-head" @click="toggleOpen(p.id)">
            <span class="social-card-icon"><LtBrand :id="p.id" :size="28" /></span>
            <span class="social-card-label">{{ p.label }}</span>
            <span class="social-card-toggle">
              <LtIcon :name="isOpen(p.id) ? 'minus' : 'plus'" :size="16" />
            </span>
          </button>
          <div v-if="isOpen(p.id)" class="social-card-body">
            <div class="input-wrap small">
              <span v-if="p.kind === 'handle'" class="input-prefix">@</span>
              <LtIcon v-else name="link" :size="16" />
              <input
                type="text"
                :data-platform="p.id"
                :value="socials[p.id] || ''"
                @input="setValue(p.id, $event.target.value)"
                :placeholder="placeholderFor(p)"
                dir="ltr"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import LtBrand from './LtBrand.vue';
import { SOCIAL_PLATFORMS, SOCIAL_GROUPS } from './data.js';

export default {
  name: 'StepSocials',
  components: { LtIcon, LtBrand },
  props: {
    data:   { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
  },
  emits: ['update'],
  data() {
    const open = {};
    for (const k of Object.keys(this.data.socials || {})) {
      if (this.data.socials[k]) open[k] = true;
    }
    return { open };
  },
  computed: {
    platforms() { return SOCIAL_PLATFORMS; },
    groups()    { return SOCIAL_GROUPS; },
    socials()   { return this.data.socials || {}; },
    count()     { return Object.values(this.socials).filter(Boolean).length; },
    bannerText() {
      return this.count > 0 ? `${this.count} נוספו` : 'אפשר לדלג';
    },
  },
  methods: {
    platformsInGroup(gid) { return this.platforms.filter((p) => p.group === gid); },
    isOpen(id)            { return !!this.open[id]; },
    hasValue(id)          { return !!(this.socials[id] && this.socials[id].trim()); },
    setValue(id, val) {
      const next = { ...this.socials };
      if (val) next[id] = val;
      else delete next[id];
      this.$emit('update', { socials: next });
    },
    toggleOpen(id) {
      if (this.open[id]) {
        this.open = { ...this.open, [id]: false };
        this.setValue(id, '');
      } else {
        this.open = { ...this.open, [id]: true };
        this.$nextTick(() => this.focusInput(id));
      }
    },
    focusInput(id) {
      const input = this.$el.querySelector(`input[data-platform="${id}"]`);
      if (input) input.focus();
    },
    placeholderFor(p) {
      return p.kind === 'handle' ? 'שם המשתמש' : 'https://...';
    },
  },
}
</script>
